import { render, staticRenderFns } from "./VehiculoPatente.vue?vue&type=template&id=67c6be02"
import script from "./VehiculoPatente.vue?vue&type=script&lang=js"
export * from "./VehiculoPatente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports